import axios from 'axios'

const API_URL = process.env.REACT_APP_ENV === 'prod' ? process.env.REACT_APP_API_PROD_URL : process.env.REACT_APP_API_DEV_URL

export function autoComplete(props: any) {
  return axios.post(`${API_URL}/search/autocomplete`, {...props})
}

export function getPartnerOptions(props: any) {
  return axios.post(`${API_URL}/search/partner/options`, {...props})
}

export function getStatus(props: any) {
  return axios.post(`${API_URL}/search/get/status`, {...props})
}

export function getSearchData(props: any) {
  return axios.post(`${API_URL}/search/list`, {...props})
}

export function deleteCompany(props: any) {
  return axios.post(`${API_URL}/search/delete_company`, {...props})
}

export function getTranslateData(props: any) {
  return axios.post(`${API_URL}/entitymetainfo/headerlabels`, {...props})
}

export function requestSqlVersionQuery(props: any) {
  return axios.post(`${API_URL}/search/requestsqlversion`, {...props})
}

export function requestXmlVersionQuery(props: any) {
  return axios.post(`${API_URL}/search/requestxmlversion`, {...props})
}

export function getSearchDataByIds(props: any) {
  return axios.post(`${API_URL}/search/listbyids`, {...props})
}

